import { faPen } from '@fortawesome/free-solid-svg-icons';
import MyIconButton from 'components/Layout/MyIconButton';

const ActionsParameterRenderer = (props) => {

  return (
    <div style={{ width: '100%' }}>
      <MyIconButton className='classic-button' type='button' iconCenter={{ icon: faPen, type: 'fontAwesome' }}
                    styleCss={{ boxShadow: 'none', color: '#bb0060', height: '20px', margin: '5px' }}
                    href={`/panneau-administration/parametrage/edition?id=${props.data.id}`} />

    </div>
  );

};

export default ActionsParameterRenderer;